// @flow
import React from 'react';
import Flex from '@waglabs/flex';

import { FooterLinksGroup } from '../FooterLinksGroup';

type Props = {
  data: {
    label: string,
    links: {
      label: string,
      path: string,
      target?: string,
    }[]
  }[]
};

export const FooterLinks = ({
  data,
}: Props) => (
  <Flex
    justifyContent={['center']}
    px={3}
    pb={4}
    width={[1, 'auto']}
    boxSizing="border-box"
  >
    <Flex
      flexDirection={['column', 'row']}
      mr={[2, 3, 0]}
    >
      {/* About Wag! & Top Wag! Cities */}
      {data.map((group, index) => index < 2
        && (
          <FooterLinksGroup
            key={group.label}
            section={group}
          />
        ))}
    </Flex>
    <Flex
      flexDirection={['column', 'row']}
      ml={[3, 0]}
    >
      {/* Resources, Lifestyles, and Legal Links */}
      {data.map((group, index) => {
        if (index === 2) {
          return (
            <FooterLinksGroup
              key={group.label}
              section={group}
            />
          );
        }
        if (index === 3) {
          // Lifestyles & Legal Links
          return (
            <Flex
              key="lifestylesLegalLinks"
              flexDirection={['column', 'column']}
            >
              {data.map((innerData, innerIndex) => {
                if (innerIndex > 2) {
                  return (
                    <FooterLinksGroup
                      key={innerData.label}
                      section={innerData}
                    />
                  );
                }
                return null;
              })}
            </Flex>
          );
        }
        return null;
      })}
    </Flex>
  </Flex>
);
